'use client';

import { useState } from 'react';

import { AuthResponse } from '@/types/common';

interface UseDemoLogin {
  isLoading: boolean;
  error: string;
  startDemo: () => Promise<void>;
}

/**
 * デモログインを実行するフック。
 * POST /auth/demo-login で認証Cookieを払い出し、成功したらダッシュボード(/projects)へ遷移する。
 * Cookie発行後はフルナビゲーションで各Context(/auth/me)を再初期化する。
 */
export const useDemoLogin = (): UseDemoLogin => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  const startDemo = async (): Promise<void> => {
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/auth/demo-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      const data = (await response.json()) as AuthResponse;

      if (!response.ok || !data.result) {
        setError(data.error || 'デモ環境に接続できませんでした');
        setIsLoading(false);
        return;
      }

      // Cookieが払い出されるため、フルナビゲーションでContextを再初期化する
      // eslint-disable-next-line @next/next/no-location-assign-relative-destination
      window.location.href = '/projects';
    } catch {
      setError('デモ環境に接続できませんでした');
      setIsLoading(false);
    }
  };

  return { isLoading, error, startDemo };
};
